import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useEffect } from "react";
import { IDS } from "@/constants/testIds";
import Footer from "@/components/Footer";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate(user.onboarded ? "/home" : "/onboarding", { replace: true });
  }, [user, loading, navigate]);

  const signIn = () => {
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-[100dvh] bg-[#FBF9F6] grain flex flex-col">
      <div className="flex-1 flex flex-col justify-between max-w-md mx-auto w-full px-8 pt-16 pb-12">
        <div>
          <img
            src="/aynora-logo.png"
            alt="Aynora"
            className="w-24 h-24 rounded-2xl shadow-[0_16px_40px_rgba(107,122,84,0.25)] mb-6"
          />
          <div className="text-xs font-[Manrope] font-bold tracking-[0.4em] uppercase text-[#6B7A54] mb-2">
            Aynora
          </div>
          <div className="text-[10px] font-[Manrope] tracking-[0.35em] uppercase text-stone-500 mb-6">
            Mirror of Light
          </div>
          <h1 className="font-[Cormorant_Garamond] text-5xl sm:text-6xl leading-[1.05] tracking-tight text-stone-900">
            Your personal<br />stylist,<br /><em className="italic font-light text-[#6B7A54]">who remembers.</em>
          </h1>
          <p className="mt-8 font-[Manrope] text-base text-stone-600 leading-relaxed max-w-xs">
            A consultant that knows your closet, what you wore last Tuesday, and who you were meeting.
          </p>
        </div>

        <div className="mt-12">
          <button
            data-testid={IDS.loginBtn}
            onClick={signIn}
            className="w-full bg-[#6B7A54] hover:bg-[#556141] text-white rounded-full px-8 py-5 font-[Manrope] font-medium tracking-wide shadow-[0_16px_40px_rgba(107, 122, 84,0.25)] active:scale-[0.98] transition-[transform,background-color]"
          >
            Continue with Google
          </button>
          <p className="mt-4 text-center text-xs font-[Manrope] text-stone-500 tracking-wide">
            Private by default. Your closet is only for you.
          </p>
          <p className="mt-3 text-center text-[11px] font-[Manrope] text-stone-500">
            By continuing you agree to our{" "}
            <a href="/terms" className="underline hover:text-[#6B7A54]">Terms</a> and{" "}
            <a href="/privacy" className="underline hover:text-[#6B7A54]">Privacy Policy</a>.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
